/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Color} from './color';

export class DialogButton {
  id: number;
  code: string;
  label: string;
  type: Type;
  color: Color;
  order: number;
  uuid: string;
}

export enum Type {
    ACCEPT = "ACCEPT",
    ACCEPT_WAIT = "ACCEPT_WAIT",
    CLOSE = "CLOSE",
    DECLINE = "DECLINE",
    DECLINE_WAIT = "DECLINE_WAIT",
    NONE = "NONE",
    NONE_WAIT = "NONE_WAIT"
}
